(() => {
  'use strict';
  const ROOT_SELECTOR = '[data-permanent-component-inquiry]';

  class PermanentComponentInquiry {
    constructor(root) {
      if (root.dataset.permanentComponentInquiryReady === 'true') return root.permanentComponentInquiry;
      root.dataset.permanentComponentInquiryReady = 'true';
      this.root = root;
      this.template = root.querySelector('[data-permanent-component-inquiry-template]');
      root.permanentComponentInquiry = this;
      this.injectScope(document);
    }

    injectScope(scope) {
      const productSections = [];
      if (scope.matches?.('[data-product-section]')) productSections.push(scope);
      scope.querySelectorAll?.('[data-product-section]').forEach((section) => productSections.push(section));
      productSections.forEach((section) => this.injectProduct(section));
    }

    injectProduct(productSection) {
      const info = productSection.querySelector('.product-info-v2');
      const form = productSection.querySelector('form[action*="/cart/add"]');
      if (!info || !form) return;

      productSection.classList.add('is-permanent-component-inquiry');
      const price = info.querySelector('.product-price-v2');
      const stockStatuses = info.querySelectorAll('.stock-status');
      if (price) price.hidden = this.root.dataset.showPrice !== 'true';
      stockStatuses.forEach((status) => { status.hidden = this.root.dataset.showStock !== 'true'; });

      if (form.dataset.permanentContactOnly !== 'true') {
        form.dataset.permanentContactOnly = 'true';
        form.addEventListener('submit', (event) => event.preventDefault());
      }

      if (!this.template || info.querySelector('[data-permanent-component-inquiry-card]')) return;
      const card = this.template.content.firstElementChild?.cloneNode(true);
      if (!card) return;
      card.dataset.permanentComponentInquiryCard = 'true';

      const pickup = info.querySelector('.pickup-card');
      const utilityLinks = info.querySelector('.product-utility-links');
      if (pickup) pickup.before(card);
      else if (utilityLinks) utilityLinks.before(card);
      else form.after(card);
    }
  }

  const initialize = (scope = document) => {
    const roots = [];
    if (scope.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));
    roots.forEach((root) => new PermanentComponentInquiry(root));
  };

  const reinject = (scope) => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const instance = root.permanentComponentInquiry || new PermanentComponentInquiry(root);
      instance?.injectScope(scope);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    reinject(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      initialize(node);
      reinject(node);
    }));
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
